import { Action, createReducer, on } from '@ngrx/store';
import { VleStore } from '../../models/store/user/vle';

import { addVle, editVle, loadVles, paginateVles, removeAllVles, removeVles } from 'src/actions/user/vle.action';

export const initialState: VleStore = {
  fetching: false,
  data: {
    vles: [],
    totalDocuments: 0
  }
};

const vlesReducer = createReducer(initialState,
  on(loadVles, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        vles: [
          ...state.data.vles,
          ...payload.filter(p => !state.data.vles.find(ds => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(addVle, (state, payload: any) => (
    {
      ...state,
      data: {
        ...state.data,
        vles: [payload,
          ...state.data.vles.slice(0, state.data.vles.length - 1)
        ],
        totalDocuments: state.data.totalDocuments + 1
      }
    })
  ),
  on(editVle, (state, payload: any) => (
    {
      ...state,
      data: {
        ...state.data,
        vles: state.data.vles.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeVles, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        vles: state.data.vles
          .filter(d => !payload.includes(String(d._master))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllVles, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        vles: [],
        totalDocuments: 0
      }
    }
  )
  ),
  // on(updateSalesExecutive, (state, payload: any) => (
  //   {
  //     ...state,
  //     data: {
  //       ...state.data,
  //       vles: state.data.vles.map(
  //         data => {
  //           console.log('+++++++++++',data._master, payload.users, payload.users.includes(String(data._master)));
  //           if (payload.users.includes(String(data._master))) {
  //             return {
  //               ...data,
  //               _srp: payload.target
  //             };
  //           }

  //           return data;
  //         }
  //       )
  //     }
  //   })
  // ),
  on(paginateVles, (state) => state)
);

export function reducer(state: VleStore, action: Action): any {
  return vlesReducer(state, action);
}
